import React from "react";
import BaseDetails, { ValueChange } from "./baseDetails";

export default function scenarioRenameDetails({ row }) {
    return (
        <BaseDetails row={row}>
            <ValueChange oldValue={row.old_value} newValue={row.new_value} />
        </BaseDetails>
    );
}
